import { usePathname } from 'next/navigation'
import { useStore } from 'zustand'

import { useSitePromotionPopupsStore } from '../../_core/hook'

import { useIsAppQuery } from '@/hooks/useIsAppQuery'
import { useSideBarData } from '@/pages/tad.ai/_layout/SideBar/data'


import { useEffect } from 'react';
export function useConsistentCharacterModalInit() {
  const store = useSitePromotionPopupsStore()
  const init = useStore(store, (s) => s.init)
  const popupPaths = useSideBarData()
  const pathname = usePathname()
  const isApp = useIsAppQuery()

  useEffect(() => {
    const allowPaths =
      pathname === '/' || popupPaths.some((path) => path.href === pathname)
    const open = !isApp && allowPaths
    init({ key: 'consistentCharacterModalV3', open })
  }, [init, isApp, pathname, popupPaths])
}
